import { all } from "redux-saga/effects";

import skillSagas from "./Skills";
import acquisitionSagas from "./Acquisition";
import trainerSagas from "./TrainersSagas";
import statesSagas from "./States";
import userSagas from "./Users";
import partnerSagas from "./PartnersSagas";
import skillSelectSagas from "./SkillSelect";
import loanStatusSagas from "./LoanStatusSagas";
import businessMgtSagas from "./Business";
import loanSagas from "./Loans";
import activitySagas from "./Activity";
import trainingCentreRegSagas from "./TrainingCentreReg";
import tregPhysicalApprovalSagas from "./tregPhysicalApprovalSagas";
import postCampActivitySagas from "./PostCampActivitySagas";
import successStorySagas from "./SuccessStorySagas";
import cmMgtSagas from "./CmMgtSagas";
import inCampActivitySagas from "./InCampActivitySagas";
import systemSettingsSagas from "./SystemSettingsSagas";

export default function* rootSaga(getState) {
  yield all([
    skillSagas(),
    acquisitionSagas(),
    trainerSagas(),
    statesSagas(),
    partnerSagas(),
    userSagas(),
    skillSelectSagas(),
    loanStatusSagas(),
    businessMgtSagas(),
    loanSagas(),
    activitySagas(),
    trainingCentreRegSagas(),
    tregPhysicalApprovalSagas(),
    postCampActivitySagas(),
    successStorySagas(),
    cmMgtSagas(),
    inCampActivitySagas(),
    systemSettingsSagas(),
  ]);
}
